// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  errors: false,
  block: false
}

const memberDirectory = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_GROUPED':
      return {
        ...state,
        data: action.data,
        params: action.params,
        block: false
      }
    case 'BLOCK':
      return { ...state, block: true }
    case 'UNBLOCK':
      return { ...state, block: false }
    default:
      return { ...state }
  }
}
export default memberDirectory
